import Component from "vue-class-component";
import { IVisits, IVisitsListItem } from "@/entity/visits/visit.types";
import { VisitsStore } from "@/store/modules/Visits";
import { mixins } from "vue-class-component";
import { DateMix } from "@/UI/mixins/Calendar/DateMix";
import dayjs from "dayjs";
import { getStudioId } from "@/UI/lib/state";

@Component
export class VisitsMix extends mixins(DateMix) {
    get visits(): IVisits | null {
        return VisitsStore.visits;
    }
    get visit(): IVisitsListItem | null {
        return VisitsStore.visit;
    }

    async parseVisits(date_from: string, date_to: string): Promise<void> {
        await VisitsStore.fetchAll({
            filter: { visit_dt_from: date_from, visit_dt_to: date_to, salon_id: getStudioId(this) },
        });
    }
    async parseVisitsCurrent(date?:any): Promise<void> {
        //const date_from = dayjs().format('DD.MM.YYYY');
        if (!date) {
            await this.parseVisits(dayjs().format("DD.MM.YYYY"), dayjs().format("DD.MM.YYYY"));
        } else {
            const dateWork = new Date(Number(date));
            const dta = dateWork.toDateString()
            const wDate = dayjs(dta).format("DD.MM.YYYY");
            await this.parseVisits(wDate, wDate);
        }
    }
}
